import { render, staticRenderFns } from "./Breakout.vue?vue&type=template&id=24c33820&scoped=true&"
import script from "./Breakout.vue?vue&type=script&lang=js&"
export * from "./Breakout.vue?vue&type=script&lang=js&"
import style0 from "./Breakout.vue?vue&type=style&index=0&id=24c33820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c33820",
  null
  
)

component.options.__file = "Breakout.vue"
export default component.exports